// UI
import Link from "../../UI/Link/Link.svelte";
// Types
import type { ActiveEditor, EventNameMap } from "../../types";
type LinkInfo = {
    displayValue: string,
    url: string,
    target: "_blank" | "_self"
}

// Export 
export default function linkSetup(editor: ActiveEditor) {
    let open = false;
    editor.ui.registry.addToggleButton("__link__", {
        icon: "link",
        onAction: function (buttonApi) {
            if (open) return;

            const isActive = buttonApi.isActive();
            const area = getEditorArea()
            let text = editor.selection.getContent({ format: 'text' })
            let url = ""

            if (isActive) {
                const node = editor.selection.getNode() as HTMLAnchorElement;
                text = node.textContent || "";
                url = node.href
                editor.selection.select(node)
            }
            editor.getBody().setAttribute('contenteditable', "false");
            const linkComponent = new Link({
                target: area,
                props: { displayValue: text, url }
            })
            open = true;
            linkComponent.$on("CANCEL", () => {
                open = false
                editor.getBody().setAttribute('contenteditable', "true");
                linkComponent.$destroy()
            })

            linkComponent.$on("SAVE", (e: { detail: LinkInfo }) => {
                const a = `<a href="${e.detail.url}" target="${e.detail.target}">${e.detail.displayValue}</a>`
                editor.getBody().setAttribute('contenteditable', "true");
                editor.selection.setContent(a)
                editor.insertContent("")
                linkComponent.$destroy()
                open = false
            })
        },
        onSetup: function (buttonApi) {
            const editorEventCallback = (eventApi: EventNameMap["NodeChange"]) =>
                buttonApi.setActive(eventApi.element.nodeName.toLowerCase() === 'a');
            editor.on('NodeChange', editorEventCallback);
        }
    });


}

function getEditorArea() {
    return document.querySelector(".tinymce-wrapper") as HTMLDivElement
}

